import React from "react";

export const LeftArrow = (props) => (
  <svg
    height="20pt"
    viewBox="0 0 512 512"
    width="20pt"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="M492,236H68.442l70.164-69.824c7.829-7.792,7.859-20.455,0.067-28.284c-7.792-7.83-20.456-7.859-28.285-0.068
			l-104.504,104c-0.007,0.006-0.012,0.013-0.018,0.019c-7.809,7.792-7.834,20.496-0.002,28.314c0.007,0.006,0.012,0.013,0.018,0.019
			l104.504,104c7.828,7.79,20.492,7.763,28.285-0.068c7.792-7.829,7.762-20.492-0.067-28.284L68.442,276H492
			c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
        />
      </g>
    </g>
  </svg>
);
export const Integrity = (props) => (
  <svg
    id="Icons"
    height="80pt"
    viewBox="0 0 74 74"
    width="80pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m49.641 71.271a1.013 1.013 0 0 1 -.3-.045 17.806 17.806 0 0 1 -2.924-1.2 1 1 0 1 1 .918-1.776 15.728 15.728 0 0 0 2.6 1.062 1 1 0 0 1 -.294 1.957z" />
    <path d="m57.229 71.77a1 1 0 0 1 -.162-1.987 15.5 15.5 0 0 0 8.4-26.247l-35-35a15.5 15.5 0 0 0 -21.929 21.928l26.1 26.1a1 1 0 0 1 -1.414 1.414l-26.1-26.1a17.5 17.5 0 1 1 24.752-24.755l35 35a17.5 17.5 0 0 1 -9.484 29.634 1.016 1.016 0 0 1 -.163.013z" />
    <path d="m41.31 65.65a1 1 0 0 1 -.707-.293l-2.17-2.17a1 1 0 0 1 1.414-1.414l2.17 2.17a1 1 0 0 1 -.707 1.707z" />
    <path d="m25.333 49.667a1 1 0 0 1 -.707-1.707l23.334-23.334a1 1 0 1 1 1.414 1.414l-23.334 23.334a1 1 0 0 1 -.707.293z" />
  </svg>
);
export const RightArrow = (props) => (
  <svg
    height="20pt"
    viewBox="0 0 512 512"
    width="20pt"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
			c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
			l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
			c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"
        />
      </g>
    </g>
  </svg>
);

export const MenuIcon = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m436.769531 74.617188c-48.335937-48.128907-112.511719-74.617188-180.765625-74.617188h-.363281c-34.804687.046875-68.578125 7.011719-100.390625 20.695312-30.675781 13.199219-58.167969 32.027344-81.714844 55.96875-48.441406 49.25-74.546875 114.199219-73.503906 182.878907.628906 41.699219 11.605469 82.980469 31.730469 119.371093.378906.683594.46875 1.449219.25 2.105469l-29.445313 88.179688c-3.78125 11.328125-1.058594 23.78125 7.109375 32.5 6.238281 6.664062 14.859375 10.300781 23.738281 10.300781 2.761719 0 5.546876-.351562 8.289063-1.070312l99.527344-26.144532c.585937-.15625 1.21875-.089844 1.78125.1875 35.382812 17.414063 73.398437 26.242188 112.984375 26.242188 68.328125 0 132.65625-26.742188 181.140625-75.292969 48.375-48.445313 74.960937-112.617187 74.859375-180.691406-.09375-68.261719-26.8125-132.40625-75.226563-180.613281zm-20.859375 340.105468c-42.8125 42.875-99.605468 66.488282-159.910156 66.488282-34.957031 0-68.515625-7.789063-99.742188-23.15625-7.035156-3.464844-15.078124-4.277344-22.648437-2.289063l-99.523437 26.144531c-.980469.257813-1.824219.015625-2.515626-.71875-1.015624-1.085937-.664062-2.140625-.546874-2.488281l29.445312-88.1875c2.867188-8.59375 1.976562-18.113281-2.453125-26.121094-17.75-32.097656-27.429687-68.515625-27.988281-105.308593-.921875-60.585938 22.125-117.902344 64.894531-161.386719 42.855469-43.570313 99.949219-67.613281 160.761719-67.699219h.316406c60.261719 0 116.929688 23.386719 159.601562 65.875 42.730469 42.546875 66.3125 99.15625 66.398438 159.398438.085938 60.054687-23.386719 116.679687-66.089844 159.449218zm0 0" />
    <path d="m353.402344 171.328125-130.953125 130.957031c-3.632813 3.632813-9.539063 3.628906-13.167969 0l-50.6875-50.6875c-5.855469-5.859375-15.355469-5.859375-21.210938 0-5.859374 5.855469-5.859374 15.355469 0 21.214844l50.6875 50.6875c7.664063 7.664062 17.730469 11.496094 27.796876 11.496094 10.066406 0 20.132812-3.832032 27.792968-11.496094l130.957032-130.960938c5.859374-5.855468 5.859374-15.355468 0-21.214843-5.855469-5.855469-15.355469-5.855469-21.214844.003906zm0 0" />
  </svg>
);

export const User = (props) => (
  <svg
    height="61pt"
    viewBox="0 0 512 512"
    width="53pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0" />
    <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0" />
  </svg>
);

export const Doctor = (props) => (
  <svg
    height="61pt"
    viewBox="0 0 512 512"
    width="53pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M366.386,271.046c29.388-28.716,47.664-68.758,47.664-112.995C414.051,70.901,343.15,0,256.001,0
			S97.95,70.901,97.95,158.05c0,44.237,18.276,84.279,47.664,112.995c-58.454,1.665-105.495,49.731-105.495,108.58v132.373h431.76
			V379.626C471.881,320.777,424.84,272.711,366.386,271.046z M256.001,30.001c45.63,0,85.755,23.996,108.438,60.027
			c-17.781,12.188-38.916,18.816-60.685,18.816c-28.699,0-55.679-11.181-75.965-31.482l-9.876-9.883l-10.559,9.15
			c-14.798,12.825-33.748,19.888-53.357,19.888c-3.333,0-6.645-0.204-9.922-0.602C165.966,56.634,207.928,30.001,256.001,30.001z
			 M127.951,158.05c0-11.638,1.57-22.915,4.493-33.64c7.068,1.387,14.272,2.106,21.551,2.106c22.321,0,44.02-6.691,62.344-19.049
			c24.555,20.321,55.133,31.378,87.414,31.378c26.245,0,51.784-7.514,73.683-21.432c4.286,12.774,6.612,26.438,6.612,40.637
			c0,66.155-50.428,120.753-114.863,127.374c-0.084,0.009-0.167,0.017-0.251,0.025c-0.928,0.094-1.86,0.175-2.794,0.249
			c-0.328,0.025-0.657,0.047-0.986,0.07c-0.75,0.053-1.501,0.103-2.254,0.143c-0.601,0.031-1.204,0.054-1.807,0.077
			c-0.525,0.021-1.049,0.046-1.576,0.06c-1.169,0.031-2.341,0.05-3.516,0.05c-1.175,0-2.347-0.019-3.516-0.05
			c-0.527-0.014-1.052-0.039-1.577-0.06c-0.602-0.023-1.204-0.045-1.805-0.077c-0.754-0.04-1.506-0.09-2.256-0.143
			c-0.328-0.023-0.656-0.045-0.984-0.07c-0.935-0.074-1.868-0.156-2.797-0.249c-0.083-0.008-0.165-0.017-0.248-0.025
			C178.381,278.804,127.951,224.206,127.951,158.05z M177.056,388.235c0,6.368-5.181,11.55-11.55,11.55s-11.549-5.181-11.549-11.55
			c0-6.368,5.181-11.549,11.549-11.549S177.056,381.867,177.056,388.235z M70.122,481.999V379.626
			c0-43.355,35.273-78.628,78.628-78.628h1.756v48.498c-15.517,6.03-26.55,21.115-26.55,38.738c0,22.911,18.64,41.551,41.551,41.551
			s41.551-18.64,41.551-41.551c0-17.623-11.034-32.709-26.55-38.738v-48.498h8.014c17.479,8.276,35.994,13.172,55.221,14.63
			c0.228,0.018,0.457,0.03,0.684,0.047c1.091,0.078,2.182,0.153,3.278,0.208c0.61,0.032,1.223,0.05,1.834,0.074
			c0.748,0.03,1.494,0.066,2.244,0.086c1.402,0.037,2.807,0.057,4.218,0.057c1.411,0,2.818-0.021,4.22-0.057
			c0.744-0.019,1.485-0.055,2.227-0.085c0.617-0.025,1.235-0.043,1.85-0.075c1.094-0.056,2.184-0.13,3.274-0.208
			c0.229-0.017,0.46-0.029,0.688-0.047c19.226-1.458,37.742-6.353,55.221-14.63h8.013v27.242
			c-32.695,6.926-57.308,36.005-57.308,70.732v38.51h-10.198v30.001h50.399v-30.001h-10.2v-38.51
			c0-23.328,18.979-42.306,42.307-42.306s42.307,18.979,42.307,42.306v38.51h-10.199v30.001h50.399v-30.001h-10.198v-38.51
			c0-34.728-24.612-63.806-57.308-70.732v-27.242h1.756c43.356,0,78.628,35.273,78.628,78.628v102.373H70.122z"
        />
      </g>
    </g>
  </svg>
);

export const ChrevronDown = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m275.565 361.679-223.897-223.896h-51.668l275.565 275.565 275.565-275.565h-51.668z" />
  </svg>
);
export const FirstAidKit = (props) => (
  <svg
    height="61pt"
    viewBox="0 0 512 512"
    width="74pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <g>
          <path
            d="M469.333,106.667H362.667V85.333c0-23.531-19.135-42.667-42.667-42.667H192c-23.531,0-42.667,19.135-42.667,42.667
				v21.333H42.667C19.135,106.667,0,125.802,0,149.333v277.333c0,23.531,19.135,42.667,42.667,42.667h426.667
				c23.531,0,42.667-19.135,42.667-42.667V149.333C512,125.802,492.865,106.667,469.333,106.667z M170.667,85.333
				C170.667,73.573,180.24,64,192,64h128c11.76,0,21.333,9.573,21.333,21.333v21.333H170.667V85.333z M490.667,426.667
				c0,11.76-9.573,21.333-21.333,21.333H42.667c-11.76,0-21.333-9.573-21.333-21.333V149.333c0-11.76,9.573-21.333,21.333-21.333
				h426.667c11.76,0,21.333,9.573,21.333,21.333V426.667z"
          />
          <path
            d="M352,256h-53.333v-53.333c0-5.896-4.771-10.667-10.667-10.667h-64c-5.896,0-10.667,4.771-10.667,10.667V256H160
				c-5.896,0-10.667,4.771-10.667,10.667v64c0,5.896,4.771,10.667,10.667,10.667h53.333v53.333c0,5.896,4.771,10.667,10.667,10.667
				h64c5.896,0,10.667-4.771,10.667-10.667v-53.333H352c5.896,0,10.667-4.771,10.667-10.667v-64
				C362.667,260.771,357.896,256,352,256z M341.333,320H288c-5.896,0-10.667,4.771-10.667,10.667V384h-42.667v-53.333
				c0-5.896-4.771-10.667-10.667-10.667h-53.333v-42.667H224c5.896,0,10.667-4.771,10.667-10.667v-53.333h42.667v53.333
				c0,5.896,4.771,10.667,10.667,10.667h53.333V320z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export const HeartRate = (props) => (
  <svg
    height="64pt"
    viewBox="0 0 512 512"
    width="72pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m290.518 434.217c-8.147 8.017-16.39 16.082-24.634 24.261-8.244-8.179-16.488-16.244-24.634-24.261-47.5-46.603-91.665-89.999-123.742-135.099h-39.839c35.069 55.571 86.845 106.382 140.292 158.825 11.96 11.733 24.066 23.612 36.173 35.718 3.246 3.246 7.497 4.868 11.749 4.868s8.504-1.623 11.749-4.868c12.106-12.106 24.212-23.985 36.173-35.718 53.447-52.443 105.224-103.254 140.292-158.825h-39.838c-32.077 45.099-76.242 88.496-123.741 135.099z" />
    <path d="m485.815 232.647c7.946-23.703 12.715-48.429 12.715-74.779 0-43.491-42.81-124.632-124.632-124.632-44.368 0-82.488 18.565-108.015 51.816-25.528-33.252-63.648-51.817-108.015-51.817-81.822 0-124.632 81.141-124.632 124.632 0 26.351 4.769 51.076 12.715 74.779h-45.951v33.235h191.428l61.472 76.857c3.197 3.976 7.984 6.232 12.983 6.232.974 0 1.947-.081 2.921-.26 5.988-1.071 10.922-5.323 12.836-11.1l39.824-119.472 30.834 41.09c3.132 4.187 8.065 6.654 13.291 6.654h166.176v-33.235zm-111.918 0-44.871-59.817c-3.7-4.95-9.834-7.497-15.952-6.443-6.102.99-11.149 5.29-13.096 11.149l-40.197 120.592-47.386-59.249c-3.164-3.943-7.936-6.232-12.983-6.232h-118.293c-9.167-23.752-14.648-48.419-14.648-74.779 0-25.17 28.107-91.397 91.397-91.397 58.243 0 84.549 40.051 93.15 57.285 5.615 11.262 24.115 11.262 29.73 0 8.601-17.234 34.907-57.285 93.15-57.285 63.29 0 91.397 66.227 91.397 91.397 0 26.361-5.481 51.027-14.648 74.779z" />
  </svg>
);
export const Injection = (props) => (
  <svg
    height="69pt"
    viewBox="0 0 512 512"
    width="69pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M414.8,0l-11.6,11.6l17.5,17.5L350.8,99l-29.1-29.1L310,81.5l11.6,11.6L69.9,344.9l17.5,17.5l-23.3,23.3L87.4,409L0,496.4
			L11.6,508L99,420.6l23.3,23.3l23.3-23.3l17.5,17.5l251.7-251.7l11.6,11.6l11.6-11.6l-29-29.1l69.9-69.9l17.5,17.4L508,93.2
			L414.8,0z M122.4,420.6l-34.9-34.9L99,374l35,35L122.4,420.6z M163.1,414.8l-69.9-69.9l82.8-82.8l29.1,29.1l11.6-11.6l-29.1-29.1
			l34.9-34.9l17.5,17.5l11.6-11.6L234.1,204l34.9-34.9l29.1,29.1l11.6-11.6l-29.1-29.1l52.4-52.4l69.9,69.9L163.1,414.8z
			 M397.3,145.6l-34.9-34.9l69.9-69.9l34.9,34.9L397.3,145.6z"
        />
      </g>
    </g>
  </svg>
);
export const Dysfunction = (props) => (
  <svg x="0px" y="0px" viewBox="0 0 427.614 427.614" fill={props.fill}>
    <g>
      <g>
        <path
          d="M333.363,28.977c-37.8-38.3-99.5-38.7-137.8-0.8c-0.3,0.3-0.5,0.5-0.8,0.8l-81,81c-1.6,0.9-2.9,2.2-3.8,3.8l-81.5,81.4
			c-38,38.1-37.9,99.8,0.1,137.8c38.3,37.9,99.9,37.9,138.3,0l0.1-0.1l81.4-81.7c0.6-0.4,1.1-0.8,1.6-1.3s0.9-1,1.3-1.6l81.3-81.5
			C370.863,128.977,371.163,67.277,333.363,28.977z M152.763,318.777c-30.5,30.1-79.6,30.2-110.1,0c-30.1-30.3-30.1-79.2,0-109.5
			l76.4-76.4l109.6,109.8L152.763,318.777z M318.463,152.477l-75.7,75.9l-109.6-109.6l75.8-75.8c30.2-30.2,79.3-30.2,109.5,0
			S348.663,122.277,318.463,152.477z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M240.863,73.777c-3.8-4-10.1-4.1-14.1-0.1l-34.6,34c-4,3.9-4,10.2-0.2,14.1c3.8,3.9,10.2,4,14.1,0.2l0.1-0.1l34.5-34
			C244.663,83.977,244.663,77.677,240.863,73.777z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M399.263,262.077c0,0,0,0-0.1-0.1c-37.3-37.9-98.3-38.3-136.2-0.9c-0.3,0.3-0.6,0.6-0.9,0.9
			c-37.9,37.9-37.9,99.3-0.1,137.2c37.8,37.9,99.3,37.9,137.2,0.1C437.063,361.377,437.063,299.977,399.263,262.077z
			 M253.663,330.577c0-42.5,34.5-77,77-77c16.9,0,33.4,5.6,46.8,15.9l-107.9,108C259.263,363.977,253.663,347.477,253.663,330.577z
			 M385.063,384.977c-27.3,27.3-70.7,30.1-101.3,6.6l107.9-107.9C415.263,314.277,412.463,357.677,385.063,384.977z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);
export const Accessories = (props) => (
  <svg
    height="80pt"
    viewBox="0 0 64 64"
    width="80pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m61 48h-40a3 3 0 0 0 0 6h21.4a12.955 12.955 0 0 0 8.6 3c6.065 0 11-3.589 11-8a1 1 0 0 0 -1-1zm-10 7a10.72 10.72 0 0 1 -7.492-2.706 1 1 0 0 0 -.708-.294h-21.8a1 1 0 0 1 0-2h38.875c-.716 2.834-4.423 5-8.875 5z" />
    <path d="m49 13h-6.72l-9.77-5.86a1 1 0 0 0 -.51-.14h-26a4 4 0 0 0 -4 4v18a4 4 0 0 0 4 4h26a1 1 0 0 0 .51-.14l9.77-5.86h6.72c2.07 0 3-3.52 3-7s-.93-7-3-7zm-37-4h1.99l.01 5h2l-.01-5h1.01v2h2v-2h1.99l.01 5h2l-.01-5h2.01v7h-13zm29 16.43-9.28 5.57h-25.72a2.006 2.006 0 0 1 -2-2v-7.76a21.928 21.928 0 0 1 5.26.73 24.8 24.8 0 0 0 6.73.81 24.823 24.823 0 0 0 6.74-.81 23.159 23.159 0 0 1 6.27-.75 23.277 23.277 0 0 1 6.27.75 23.932 23.932 0 0 0 5.73.79zm0-4.67a22.105 22.105 0 0 1 -5.27-.73 24.678 24.678 0 0 0 -6.73-.81 24.823 24.823 0 0 0 -6.74.81 23.159 23.159 0 0 1 -6.27.75 23.132 23.132 0 0 1 -6.26-.75 23.932 23.932 0 0 0 -5.73-.79v-8.24a2.006 2.006 0 0 1 2-2h4v8a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-8h4.72l9.28 5.57zm5.8 4.24h-3.8v-10h3.8a14.025 14.025 0 0 0 -.8 5 14.025 14.025 0 0 0 .8 5zm2.2-.09c-.37-.47-1-2.15-1-4.91s.63-4.44 1-4.91c.37.47 1 2.15 1 4.91s-.63 4.44-1 4.91z" />
    <path d="m51.22 29.375c-.534.666-5.22 6.6-5.22 9.625a6 6 0 0 0 12 0c0-3.025-4.686-8.959-5.22-9.625a1.033 1.033 0 0 0 -1.56 0zm4.78 9.625a4 4 0 0 1 -8 0c0-1.521 2.208-4.972 4-7.365 1.792 2.393 4 5.844 4 7.365z" />
    <path d="m53 38h2v2h-2z" />
  </svg>
);
export const Medicine = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M179.149,281.6c-0.077,0-0.154,0-0.23,0c-72.201,0-136.687,17.852-164.326,45.491C4.898,336.785-0.009,347.29,0,358.315
			c0.026,43.059,78.746,76.834,179.217,76.885c0.077,0,0.154,0,0.23,0c72.192,0,136.678-17.852,164.318-45.491
			c9.694-9.694,14.601-20.198,14.592-31.224C358.34,315.426,279.62,281.651,179.149,281.6z M331.699,377.634
			c-24.235,24.235-85.393,40.499-152.26,40.499c-0.068,0-0.154,0-0.222,0c-95.539-0.051-162.133-31.573-162.15-59.827
			c0-6.332,3.226-12.774,9.591-19.14c24.235-24.235,85.393-40.499,152.26-40.499c0.068,0,0.145,0,0.222,0
			c95.539,0.051,162.133,31.573,162.15,59.827C341.299,364.826,338.065,371.268,331.699,377.634z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M358.357,358.494c0-4.719-3.823-8.533-8.533-8.533c-4.719,0-8.533,3.823-8.533,8.533
			c0.009,6.332-3.226,12.774-9.591,19.14c-24.235,24.235-85.393,40.499-152.26,40.499c-0.068,0-0.154,0-0.222,0
			c-95.539-0.051-162.133-31.573-162.15-59.819c0-4.719-3.823-8.533-8.533-8.533c-4.719,0-8.533,3.823-8.533,8.533l0.043,76.8
			C0.068,478.174,78.788,511.949,179.251,512c0.085,0,0.162,0,0.239,0c98.628,0,176.631-32.998,178.807-75.366
			c0.068-0.444,0.102-0.888,0.102-1.34L358.357,358.494z M341.274,435.14c-0.512,28.297-67.063,59.793-161.783,59.793
			c-0.077,0-0.154,0-0.23,0c-95.539-0.051-162.133-31.573-162.15-59.827l-0.026-43.52c28.45,25.975,89.626,43.58,162.133,43.614
			c0.077,0,0.145,0,0.23,0c70.135,0,132.992-16.845,161.86-43.153l0.026,42.214C341.299,434.552,341.274,434.842,341.274,435.14z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M349.867,349.867H8.533C3.823,349.867,0,353.69,0,358.4s3.823,8.533,8.533,8.533h341.333c4.71,0,8.533-3.823,8.533-8.533
			S354.577,349.867,349.867,349.867z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M182.315,73.694c-29.943-29.943-78.669-29.943-108.612,0c-3.337,3.337-3.337,8.73,0,12.066
			c3.328,3.337,8.738,3.337,12.066,0c23.287-23.287,61.184-23.287,84.471,0c1.664,1.664,3.849,2.5,6.033,2.5s4.369-0.828,6.042-2.5
			C185.651,82.423,185.651,77.03,182.315,73.694z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M345.66,163.763c-3.337-3.337-8.738-3.337-12.066,0L211.49,285.875c-3.337,3.337-3.337,8.73,0,12.066
			c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5L345.66,175.829C348.996,172.493,348.996,167.1,345.66,163.763z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M474.325,292.429L219.571,37.675C195.277,13.38,162.978,0,128.623,0C94.268,0,61.969,13.38,37.675,37.675
			C13.38,61.961,0,94.268,0,128.623c0,34.355,13.38,66.654,37.675,90.948l80.299,80.299c1.886,1.894,4.531,2.79,7.194,2.423
			c17.647-2.415,36.036-3.849,53.973-3.627c95.539,0.051,162.133,31.573,162.159,59.81l0.043,75.767
			c-0.034,0.29-0.06,0.58-0.06,0.879c-0.222,12.134-12.86,25.156-34.68,35.738c-2.662,1.297-4.471,3.866-4.77,6.81
			c-0.299,2.944,0.939,5.837,3.285,7.637c23.125,17.8,50.739,26.547,78.251,26.547c33.126,0,66.108-12.681,90.957-37.53
			C498.62,450.039,512,417.732,512,383.377C512,349.022,498.62,316.723,474.325,292.429z M462.251,462.259
			c-36.233,36.233-92.407,42.633-135.578,17.084c19.994-12.322,30.839-26.906,31.625-42.735c0.068-0.435,0.102-0.879,0.102-1.323
			l-0.043-76.8c-0.017-43.059-78.737-76.834-179.209-76.885c-0.06,0-0.119,0-0.179,0c-17.442,0-34.876,1.084-51.9,3.234
			l-77.329-77.329c-21.069-21.069-32.674-49.084-32.674-78.882S28.672,70.81,49.741,49.741
			c21.069-21.069,49.084-32.674,78.882-32.674s57.813,11.605,78.882,32.674l254.754,254.754
			c21.069,21.069,32.674,49.084,32.674,78.882S483.328,441.19,462.251,462.259z"
        />
      </g>
    </g>
  </svg>
);
export const Medicine2 = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path d="M125.696,125.994c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S131.216,125.994,125.696,125.994z" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M215.691,312.984h-29.998v-29.998c0-5.522-4.478-10-10-10s-9.999,4.478-9.999,10v29.998h-29.998
			c-5.522,0-10,4.478-10,9.999s4.478,10,10,10h29.998v29.998c0,5.522,4.478,10,9.999,10s10-4.478,10-10v-29.998h29.998
			c5.522,0,10-4.478,10-10S221.214,312.984,215.691,312.984z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M485.578,321.984c-22.105-38.286-70.981-51.389-109.274-29.279l-40.618,23.45v-86.836c0-10.735-3.55-21.388-9.999-29.998
			l-49.997-66.661v-28.386c11.638-4.128,19.999-15.242,19.999-28.279V29.998C295.687,13.457,282.23,0,265.689,0H85.698
			C69.157,0,55.699,13.457,55.699,29.998v45.998c0,13.035,8.361,24.151,19.999,28.279v28.386l-50.001,66.665
			c-6.446,8.606-9.996,19.258-9.996,29.993v193.66c0,27.569,22.429,49.997,49.997,49.997h160.702
			c22.421,37.583,70.767,50.161,108.664,28.279L456.3,431.258C494.255,409.34,507.794,360.479,485.578,321.984z M75.698,29.998
			c0-5.514,4.486-10,9.999-10h179.991c5.514,0,10,4.486,10,10v45.998c0,5.514-4.486,9.999-10,9.999H85.698
			c-5.514,0-9.999-4.486-9.999-9.999V29.998z M41.701,211.319l51.996-69.326c1.298-1.73,2-3.836,2-6v-29.998h159.992v19.999h-89.995
			c-5.522,0-10,4.478-10,10s4.478,10,10,10h94.995l48.993,65.322c3.202,4.275,5.191,9.39,5.792,14.674H35.913
			C36.513,220.705,38.502,215.59,41.701,211.319z M65.699,452.977c-16.541,0-29.998-13.457-29.998-29.998v-10.099h181.675
			c-3.171,12.965-3.15,26.813,0.481,40.098H65.699z M225.219,392.98H35.7V245.987h279.986V327.7l-60.619,35.002
			C242.428,370.003,232.212,380.396,225.219,392.98z M325.066,483.935c-28.697,16.571-65.367,6.771-81.949-21.946
			c-16.661-28.994-6.564-65.498,21.952-81.969l54.277-31.338l59.997,103.915L325.066,483.935z M446.3,413.939l-49.637,28.659
			l-59.998-103.917l49.638-28.656c28.716-16.578,65.373-6.761,81.955,21.957C484.913,360.844,474.785,397.49,446.3,413.939z"
        />
      </g>
    </g>
  </svg>
);
export const Medicine3 = (props) => (
  <svg
    height="64pt"
    viewBox="0 0 512 512"
    width="64pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M236.177,115.507c-16.58-16.572-55.415,7.151-84.471,36.207c-29.065,29.056-52.787,67.891-36.207,84.471
			c3.789,3.789,8.73,5.47,14.455,5.47c19.345,0,47.599-19.251,70.016-41.677C229.035,170.923,252.757,132.087,236.177,115.507z
			 M187.895,187.904c-31.676,31.676-57.233,39.322-60.339,36.207c-3.098-3.098,4.531-28.664,36.207-60.339
			c27.452-27.443,50.313-36.838,57.941-36.838c1.178,0,1.988,0.222,2.398,0.631C227.2,130.662,219.563,156.228,187.895,187.904z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M236.186,115.499l-90.513-90.505C129.553,8.883,108.126,0,85.333,0s-44.22,8.875-60.339,24.994
			c-33.271,33.271-33.271,87.407,0,120.678l90.505,90.513c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.042-2.509
			c3.336-3.328,3.336-8.73,0-12.066c-3.098-3.098,4.531-28.664,36.207-60.339s57.225-39.305,60.339-36.207
			c3.337,3.336,8.738,3.336,12.066,0C239.522,124.228,239.522,118.835,236.186,115.499z M151.706,151.706
			c-17.843,17.835-33.673,39.356-39.398,57.148l-75.255-75.255c-26.615-26.615-26.615-69.922,0-96.538
			c12.894-12.894,30.037-19.994,48.273-19.994c18.236,0,35.379,7.108,48.273,19.994l75.255,75.247
			C191.061,118.042,169.549,133.871,151.706,151.706z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M360.277,151.714c-29.056-29.065-67.9-52.813-84.471-36.207c-16.58,16.58,7.142,55.407,36.207,84.471
			c22.426,22.426,50.671,41.677,70.025,41.677c5.717,0,10.667-1.69,14.447-5.47C413.065,219.605,389.333,180.77,360.277,151.714z
			 M384.427,224.12c-3.098,3.081-28.663-4.54-60.339-36.207c-31.676-31.676-39.305-57.233-36.207-60.339s28.663,4.531,60.339,36.207
			C379.896,195.456,387.524,221.022,384.427,224.12z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M487.006,25.003c-16.119-16.12-37.547-24.994-60.339-24.994s-44.22,8.875-60.339,24.994l-90.505,90.505
			c-3.337,3.337-3.337,8.73,0,12.066c3.328,3.336,8.73,3.336,12.066,0c3.106-3.081,28.672,4.54,60.339,36.207
			c31.667,31.676,39.305,57.242,36.198,60.339c-3.337,3.336-3.337,8.738,0,12.066c1.664,1.664,3.849,2.5,6.033,2.5
			c2.185,0,4.36-0.836,6.042-2.492l90.505-90.513C520.277,112.41,520.277,58.274,487.006,25.003z M474.931,133.606l-75.247,75.255
			c-5.734-17.792-21.564-39.305-39.398-57.148c-17.835-17.843-39.356-33.664-57.148-39.398l75.247-75.247
			c12.894-12.885,30.037-19.994,48.273-19.994c18.236,0,35.379,7.1,48.273,19.994C501.547,63.684,501.547,106.991,474.931,133.606z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M213.325,247.467c-14.114,0-25.6,11.486-25.6,25.6c0,14.114,11.486,25.6,25.6,25.6c14.123,0,25.6-11.486,25.6-25.6
			C238.925,258.953,227.439,247.467,213.325,247.467z M213.325,281.6c-4.71,0-8.533-3.831-8.533-8.533
			c0-4.702,3.823-8.533,8.533-8.533c4.71,0,8.533,3.831,8.533,8.533C221.858,277.769,218.027,281.6,213.325,281.6z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M290.125,281.6c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133s34.133-15.309,34.133-34.133
			C324.258,296.909,308.949,281.6,290.125,281.6z M290.125,332.8c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C307.191,325.146,299.537,332.8,290.125,332.8z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M290.125,384c-14.114,0-25.6,11.486-25.6,25.6s11.486,25.6,25.6,25.6c14.123,0,25.6-11.486,25.6-25.6
			S304.239,384,290.125,384z M290.125,418.133c-4.71,0-8.533-3.831-8.533-8.533s3.823-8.533,8.533-8.533s8.533,3.831,8.533,8.533
			S294.827,418.133,290.125,418.133z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M273.058,187.733c-18.825,0-34.133,15.309-34.133,34.133S254.234,256,273.058,256s34.133-15.309,34.133-34.133
			S291.883,187.733,273.058,187.733z M273.058,238.933c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067
			c9.412,0,17.067,7.654,17.067,17.067C290.125,231.279,282.47,238.933,273.058,238.933z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M213.325,332.8c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133c18.825,0,34.133-15.309,34.133-34.133
			S232.149,332.8,213.325,332.8z M213.325,384c-9.412,0-17.067-7.654-17.067-17.067s7.654-17.067,17.067-17.067
			c9.412,0,17.067,7.654,17.067,17.067S222.737,384,213.325,384z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M230.391,443.733c-18.825,0-34.133,15.309-34.133,34.133S211.567,512,230.391,512s34.133-15.309,34.133-34.133
			S249.216,443.733,230.391,443.733z M230.391,494.933c-9.412,0-17.067-7.654-17.067-17.067s7.654-17.067,17.067-17.067
			c9.412,0,17.067,7.654,17.067,17.067S239.804,494.933,230.391,494.933z"
        />
      </g>
    </g>
  </svg>
);
export const Meds = (props) => (
  <svg
    height="64pt"
    viewBox="0 0 512 512"
    width="64pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m472.429688 39.5625c-25.496094-25.511719-59.414063-39.5625-95.488282-39.5625-36.078125 0-69.984375 14.050781-95.492187 39.5625l-120.945313 120.941406-120.949218 120.957032c-25.503907 25.511718-39.554688 59.429687-39.554688 95.496093 0 36.066407 14.050781 69.984375 39.554688 95.480469 25.496093 25.511719 59.414062 39.5625 95.488281 39.5625s69.984375-14.050781 95.488281-39.5625l120.949219-120.941406 120.949219-120.957032c25.503906-25.511718 39.550781-59.429687 39.550781-95.496093 0-36.066407-14.046875-69.984375-39.550781-95.480469zm-267.359376 407.414062c-18.710937 18.707032-43.582031 29.015626-70.027343 29.015626-26.457031 0-51.320313-10.304688-70.027344-29.015626-18.707031-18.710937-29.003906-43.570312-29.003906-70.015624 0-26.445313 10.304687-51.328126 29.003906-70.035157l108.21875-108.226562 140.054687 140.070312zm241.898438-241.898437-108.21875 108.226563-140.054688-140.070313 108.21875-108.210937c18.707032-18.707032 43.578126-29.015626 70.027344-29.015626 26.453125 0 51.316406 10.304688 70.023438 29.015626 18.707031 18.710937 29.003906 43.570312 29.003906 70.015624 0 26.445313-10.300781 51.328126-29 70.039063zm0 0" />
    <path d="m425.09375 121.414062c-5.742188 0-11.386719-2.742187-14.875-7.824218-8.425781-12.308594-22.324219-19.640625-37.191406-19.640625-12.027344 0-23.324219 4.675781-31.835938 13.1875-7.035156 7.03125-18.429687 7.03125-25.460937 0-7.03125-7.035157-7.03125-18.429688 0-25.460938 15.308593-15.316406 35.652343-23.738281 57.296875-23.738281 26.753906 0 51.765625 13.1875 66.90625 35.292969 5.617187 8.207031 3.527344 19.410156-4.683594 25.039062-3.105469 2.125-6.648438 3.144531-10.15625 3.144531zm0 0" />
  </svg>
);
export const Nutrition = (props) => (
  <svg
    height="60pt"
    viewBox="0 0 512 512"
    width="80pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <path d="m412.6 405.096v-182.214c0-.005.001-.01.001-.015s-.001-.01-.001-.015v-66.252c0-10.474-3.968-20.395-11.183-27.983-.059-.068-.119-.134-.181-.2l-38.336-41.042v-22.675h9.066c4.143 0 7.5-3.358 7.5-7.5v-33.132c.001-13.271-10.796-24.068-24.067-24.068h-198.798c-13.271 0-24.068 10.797-24.068 24.068v33.132c0 4.142 3.358 7.5 7.5 7.5h9.067v22.675l-38.336 41.042c-.055.06-.11.12-.163.181-7.227 7.59-11.201 17.519-11.201 28.003v33.133 66.267c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-25.634h283.2v167.233h-283.2v-111.733c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v152.367 33.133c0 22.405 18.228 40.633 40.633 40.633h231.934c22.405 0 40.634-18.228 40.634-40.633v-66.262c0-.001 0-.003 0-.004s-.001-.003-.001-.005zm-265.067-381.028c0-5 4.068-9.068 9.068-9.068h198.799c5 0 9.067 4.068 9.067 9.068v25.632h-9.067-9.066v-9.067c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-18.134v-9.067c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-18.134v-9.067c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-18.133v-9.067c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-18.133v-9.067c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-18.133v-9.067c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v9.067h-9.067-9.067zm-25.894 114.691c.115-.119.226-.241.332-.366l37.886-40.56h29.876c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-25.633v-18.133h183.8v18.133h-25.634c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h29.877l37.87 40.544c.11.13.227.258.347.382 4.668 4.813 7.239 11.148 7.239 17.841v25.634h-283.2v-25.633c0-6.694 2.571-13.03 7.24-17.842zm-7.24 76.608v-18.133h283.2v18.133zm283.201 197.234v18.133h-283.2v-18.133zm-25.633 84.399h-231.934c-14.134 0-25.633-11.499-25.633-25.633v-25.633h283.201v25.633c0 14.134-11.499 25.633-25.634 25.633z" />
      <path d="m255.446 360.288 23.429-23.429 23.43-23.429c12.612-12.613 12.612-33.136-.001-45.749-6.11-6.11-14.233-9.475-22.875-9.475-8.641 0-16.765 3.365-22.874 9.475l-23.424 23.424c-.002.002-.003.003-.005.005s-.003.003-.005.005l-23.424 23.424c-12.613 12.613-12.613 33.136 0 45.75 6.307 6.308 14.59 9.461 22.875 9.46 8.282-.002 16.568-3.155 22.874-9.461zm11.715-82.001c3.276-3.277 7.634-5.082 12.268-5.082 4.635 0 8.992 1.805 12.269 5.082 6.765 6.765 6.765 17.772 0 24.537l-18.126 18.126-24.536-24.537zm-46.858 71.394c-6.765-6.765-6.765-17.772 0-24.537l18.126-18.126 24.536 24.537-18.125 18.125c-6.766 6.766-17.773 6.766-24.537.001z" />
      <path d="m331.334 371.967c0 4.142 3.357 7.5 7.5 7.5h33.133c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-33.133c-4.143 0-7.5 3.358-7.5 7.5z" />
      <path d="m371.967 346.334c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-16.567c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z" />
      <path d="m180.666 272.567c0-13.27-10.796-24.067-24.067-24.067s-24.066 10.796-24.066 24.067c0 13.27 10.796 24.066 24.066 24.066 13.271.001 24.067-10.796 24.067-24.066zm-33.133 0c0-4.999 4.067-9.067 9.066-9.067s9.067 4.067 9.067 9.067c0 4.999-4.067 9.066-9.067 9.066-4.998.001-9.066-4.067-9.066-9.066z" />
    </g>
  </svg>
);
export const Pharmacy = (props) => (
  <svg
    height="68pt"
    viewBox="0 0 512 512"
    width="68pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m497 160.667h-145.667v-145.667c0-8.284-6.716-15-15-15h-160.666c-8.284 0-15 6.716-15 15v145.667h-145.667c-8.284 0-15 6.716-15 15v160.666c0 8.284 6.716 15 15 15h145.667v145.667c0 8.284 6.716 15 15 15h160.666c8.284 0 15-6.716 15-15v-145.667h145.667c8.284 0 15-6.716 15-15v-160.666c0-8.284-6.716-15-15-15zm-15 160.666h-145.667c-8.284 0-15 6.716-15 15v145.667h-130.666v-145.667c0-8.284-6.716-15-15-15h-145.667v-130.666h145.667c8.284 0 15-6.716 15-15v-145.667h130.666v145.667c0 8.284 6.716 15 15 15h145.667z" />
  </svg>
);
export const Plus2 = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M492,236H276V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v216H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h216
			v216c0,11.046,8.954,20,20,20s20-8.954,20-20V276h216c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
        />
      </g>
    </g>
  </svg>
);

export const Remove = (props) => (
  <svg
    height="57pt"
    viewBox="0 0 512 512"
    width="57pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m256 0c-141.386719 0-256 114.613281-256 256s114.613281 256 256 256 256-114.613281 256-256c-.167969-141.316406-114.683594-255.832031-256-256zm0 480c-123.710938 0-224-100.289062-224-224s100.289062-224 224-224 224 100.289062 224 224c-.132812 123.65625-100.34375 223.867188-224 224zm0 0" />
    <path d="m380.449219 131.550781c-6.25-6.246093-16.378907-6.246093-22.625 0l-101.824219 101.824219-101.824219-101.824219c-6.140625-6.355469-16.269531-6.53125-22.625-.390625-6.355469 6.136719-6.53125 16.265625-.390625 22.621094.128906.132812.257813.265625.390625.394531l101.824219 101.824219-101.824219 101.824219c-6.355469 6.136719-6.53125 16.265625-.390625 22.625 6.136719 6.355469 16.265625 6.53125 22.621094.390625.132812-.128906.265625-.257813.394531-.390625l101.824219-101.824219 101.824219 101.824219c6.355469 6.136719 16.484375 5.960937 22.621093-.394531 5.988282-6.199219 5.988282-16.03125 0-22.230469l-101.820312-101.824219 101.824219-101.824219c6.246093-6.246093 6.246093-16.375 0-22.625zm0 0" />{" "}
  </svg>
);
export const Chat = (props) => (
  <svg
    height="57pt"
    viewBox="0 0 512 512"
    width="57pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m436.769531 74.617188c-48.335937-48.128907-112.511719-74.617188-180.765625-74.617188h-.363281c-34.804687.046875-68.578125 7.011719-100.390625 20.695312-30.675781 13.199219-58.167969 32.027344-81.714844 55.96875-48.441406 49.25-74.546875 114.199219-73.503906 182.878907.628906 41.699219 11.605469 82.980469 31.730469 119.371093.378906.683594.46875 1.449219.25 2.105469l-29.445313 88.179688c-3.78125 11.328125-1.058594 23.78125 7.109375 32.5 6.238281 6.664062 14.859375 10.300781 23.738281 10.300781 2.761719 0 5.546876-.351562 8.289063-1.070312l99.527344-26.144532c.585937-.15625 1.21875-.089844 1.78125.1875 35.382812 17.414063 73.398437 26.242188 112.984375 26.242188 68.328125 0 132.65625-26.742188 181.140625-75.292969 48.375-48.445313 74.960937-112.617187 74.859375-180.691406-.09375-68.261719-26.8125-132.40625-75.226563-180.613281zm-20.859375 340.105468c-42.8125 42.875-99.605468 66.488282-159.910156 66.488282-34.957031 0-68.515625-7.789063-99.742188-23.15625-7.035156-3.464844-15.078124-4.277344-22.648437-2.289063l-99.523437 26.144531c-.980469.257813-1.824219.015625-2.515626-.71875-1.015624-1.085937-.664062-2.140625-.546874-2.488281l29.445312-88.1875c2.867188-8.59375 1.976562-18.113281-2.453125-26.121094-17.75-32.097656-27.429687-68.515625-27.988281-105.308593-.921875-60.585938 22.125-117.902344 64.894531-161.386719 42.855469-43.570313 99.949219-67.613281 160.761719-67.699219h.316406c60.261719 0 116.929688 23.386719 159.601562 65.875 42.730469 42.546875 66.3125 99.15625 66.398438 159.398438.085938 60.054687-23.386719 116.679687-66.089844 159.449218zm0 0" />
    <path d="m353.402344 171.328125-130.953125 130.957031c-3.632813 3.632813-9.539063 3.628906-13.167969 0l-50.6875-50.6875c-5.855469-5.859375-15.355469-5.859375-21.210938 0-5.859374 5.855469-5.859374 15.355469 0 21.214844l50.6875 50.6875c7.664063 7.664062 17.730469 11.496094 27.796876 11.496094 10.066406 0 20.132812-3.832032 27.792968-11.496094l130.957032-130.960938c5.859374-5.855468 5.859374-15.355468 0-21.214843-5.855469-5.855469-15.355469-5.855469-21.214844.003906zm0 0" />
  </svg>
);
export const Cancel = (props) => (
  <svg
    height="15pt"
    viewBox="0 0 511.058 511.058"
    width="15pt"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m511.058 60.811-60.811-60.811-194.718 194.718-194.718-194.718-60.811 60.811 194.718 194.718-194.718 194.718 60.811 60.811 194.718-194.718 194.718 194.718 60.811-60.811-194.718-194.718z" />
    </g>
  </svg>
);
export const Tablet = (props) => (
  <svg
    height="75pt"
    viewBox="0 0 60 60"
    width="85pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m63 18.997h-15v-2c0-.553-.447-1-1-1h-6.999-39.001c-.553 0-1 .447-1 1v30.006c0 .553.447 1 1 1h39.001 6.999c.553 0 1-.447 1-1v-2h15c.553 0 1-.447 1-1v-24.006c0-.553-.447-1-1-1zm-21.999 0v-1h4.999v1zm-39.001-1h37.001v1.985c0 .005-.003.01-.003.015s.003.01.003.015v23.977c0 .005-.003.01-.003.015s.003.01.003.015v1.985h-37.001zm44 28.006h-4.999v-1h4.999zm16-3h-20.999v-22.006h20.999z" />
    <path d="m42.001 27.002c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4zm6 0c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2z" />
    <path d="m56.002 31.002c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z" />
    <path d="m46.001 33.002c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" />
    <path d="m56.002 41.002c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z" />
    <path d="m20.5 33.005c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5zm0-11c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5-4.5-2.019-4.5-4.5 2.019-4.5 4.5-4.5z" />
    <path d="m19.5 27.505v1.501c0 .553.447 1 1 1s1-.447 1-1v-1.501h1.501c.553 0 1-.447 1-1s-.447-1-1-1h-1.501v-1.501c0-.553-.447-1-1-1s-1 .447-1 1v1.501h-1.501c-.553 0-1 .447-1 1s.447 1 1 1z" />
    <path d="m32.007 35.008h-23c-.553 0-1 .447-1 1s.447 1 1 1h23c.553 0 1-.447 1-1s-.447-1-1-1z" />
    <path d="m32.007 38.005h-23c-.553 0-1 .447-1 1s.447 1 1 1h23c.553 0 1-.447 1-1s-.447-1-1-1z" />
    <path d="m24.999 41.005h-8.986c-.553 0-1 .447-1 1s.447 1 1 1h8.986c.553 0 1-.447 1-1s-.447-1-1-1z" />{" "}
  </svg>
);
export const Drugs = (props) => (
  <svg
    height="66pt"
    viewBox="0 0 512 512"
    width="66pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M443.393,259.503l29.041-29.041c52.753-52.753,52.759-138.138,0-190.896c-52.751-52.752-138.137-52.759-190.895,0
			C270.279,50.824,49.78,271.325,39.567,281.538c-52.753,52.753-52.759,138.138,0,190.896c52.751,52.752,138.137,52.759,190.895,0
			l29.042-29.041c23.216,40.911,67.177,68.577,117.482,68.577c74.43,0,134.984-60.554,134.984-134.984
			C511.97,326.68,484.305,282.719,443.393,259.503z M242.002,376.985c0,12.635,1.75,24.869,5.011,36.477l-37.761,37.761
			c-41.029,41.028-107.44,41.034-148.474,0c-41.029-41.028-41.035-107.44,0-148.474l109.465-109.465l100.512,100.511
			C252.75,316.736,242.002,345.629,242.002,376.985z M361.987,480.897c-50.811-7.3-89.989-51.113-89.989-103.912
			c0-52.799,39.178-96.612,89.989-103.912V480.897z M291.766,272.386L191.453,172.073L302.749,60.777
			c41.029-41.028,107.44-41.034,148.474,0c41.029,41.028,41.035,107.44,0,148.474l-37.761,37.761
			c-11.608-3.262-23.841-5.011-36.476-5.011C344.696,242.001,315.022,253.404,291.766,272.386z M391.984,480.897V273.074
			c50.811,7.3,89.989,51.113,89.989,103.912C481.973,429.784,442.795,473.597,391.984,480.897z"
        />
      </g>
    </g>{" "}
  </svg>
);
export const QrCode = (props) => (
  <svg
    height="70pt"
    viewBox="0 0 512 512"
    width="61pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <path d="m30 30h90v-30h-120v120h30zm0 0" />
    <path d="m392 0v30h90v90h30v-120zm0 0" />
    <path d="m482 482h-90v30h120v-120h-30zm0 0" />
    <path d="m30 392h-30v120h120v-30h-90zm0 0" />
    <path d="m61 60v150h150v-90h30v-30h-30v-30zm120 120h-90v-90h90zm0 0" />
    <path d="m451 450v-150h-60v-30h-30v30h-90v30h30v30h-30v30h30v60zm-120-120h90v90h-90zm0 0" />
    <path d="m151 270h60v-30h-150v30h60v30h-30v30h30v60h-30v30h30v30h150v-30h-30v-30h-30v30h-60v-30h30v-30h-30zm0 0" />
    <path d="m121 120h30v30h-30zm0 0" />
    <path d="m361 120h30v30h-30zm0 0" />
    <path d="m391 210h60v-150h-150v150h60v30h30zm-60-30v-90h90v90zm0 0" />
    <path d="m451 270v-30c-7.257812 0-52.691406 0-60 0v30zm0 0" />
    <path d="m361 360h30v30h-30zm0 0" />
    <path d="m241 330h30v30h-30zm0 0" />
    <path d="m181 360h30c0-7.257812 0-52.691406 0-60h-30zm0 0" />
    <path d="m211 270h30v30h-30zm0 0" />
    <path d="m91 330h-30v60h30c0-7.257812 0-52.691406 0-60zm0 0" />
    <path d="m61 420h30v30h-30zm0 0" />
    <path d="m241 60h30v30h-30zm0 0" />
    <path d="m241 180h30c0-7.257812 0-52.691406 0-60h-30zm0 0" />
    <path d="m271 240v-30h-30v60h120v-30zm0 0" />
  </svg>
);
export const Code = (props) => (
  <svg
    height="512pt"
    viewBox="0 0 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
  >
    <g>
      <g>
        <path
          d="M57.015,88.1H26.112C11.715,88.1,0,99.813,0,114.212v283.575c0,14.398,11.715,26.112,26.112,26.112h30.902
			c14.398,0,26.111-11.714,26.111-26.112V114.212C83.126,99.813,71.413,88.1,57.015,88.1z M53.127,393.9H29.999V118.099h23.128
			V393.9z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M162.794,88.1h-30.902c-14.398,0-26.112,11.714-26.112,26.112v166.887c0,14.398,11.715,26.112,26.112,26.112h30.902
			c14.398-0.001,26.111-11.715,26.111-26.113V114.212C188.905,99.814,177.191,88.1,162.794,88.1z M158.906,277.211h-23.128V118.099
			h23.128V277.211z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M268.572,88.1h-30.901c-14.398,0-26.112,11.714-26.112,26.112v166.887c-0.001,14.398,11.714,26.111,26.112,26.111h30.901
			c14.398,0,26.112-11.714,26.112-26.112V114.212C294.684,99.814,282.969,88.1,268.572,88.1z M264.685,277.211h-23.128V118.099
			h23.128V277.211z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M376.989,88.1h-30.902c-14.398,0-26.112,11.714-26.112,26.112v166.887c0,14.398,11.715,26.112,26.112,26.112h30.902
			c14.398,0,26.111-11.714,26.111-26.112V114.212C403.1,99.813,391.387,88.1,376.989,88.1z M373.101,277.211h-23.128V118.099h23.128
			V277.211z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M485.888,88.1h-30.902c-14.398,0-26.111,11.714-26.111,26.112v283.575c0,14.398,11.714,26.112,26.111,26.112h30.902
			c14.398,0,26.111-11.714,26.111-26.112V114.212C512,99.813,500.286,88.1,485.888,88.1z M482.001,393.9h-23.127V118.099h23.127
			V393.9z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M129.51,330.471c-1.564-1.017-3.291-1.527-5.181-1.527c-1.31,0-2.364,0.255-3.164,0.764l-14.398,8.727
			c-2.11,1.237-3.163,3.163-3.163,5.781c0,1.745,0.508,3.31,1.526,4.69c1.018,1.382,2.291,2.073,3.818,2.073
			c0.944,0,1.854-0.29,2.727-0.873l3.164-1.963v55.521c0,1.674,0.835,2.964,2.509,3.872c1.672,0.91,3.671,1.364,5.999,1.364
			c2.327,0,4.326-0.454,6-1.364c1.672-0.908,2.509-2.198,2.509-3.872V334.29C131.855,332.762,131.073,331.491,129.51,330.471z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M186.144,394.068h-28.765v-0.992c0.001-1.767,1.179-3.697,3.536-5.793c2.357-2.095,5.198-4.246,8.523-6.451
			c3.324-2.206,6.631-4.633,9.918-7.279c3.288-2.646,6.103-5.918,8.44-9.814c2.339-3.896,3.508-8.051,3.508-12.462
			c0-6.767-2.557-12.144-7.67-16.132c-5.113-3.988-11.064-5.982-17.856-5.982c-6.589,0-12.326,1.909-17.212,5.727
			c-4.886,3.818-7.328,8.89-7.328,15.216c0,5.89,2.51,8.835,7.535,8.835c2.655,0,4.789-0.641,6.405-1.924
			c1.613-1.282,2.422-2.792,2.422-4.528c0-2.944,0.773-5.095,2.321-6.453c1.547-1.358,3.536-2.039,5.969-2.039
			c2.799,0,4.898,0.791,6.3,2.371c1.398,1.582,2.1,3.4,2.1,5.459c0,2.574-1.198,5.221-3.593,7.941
			c-2.396,2.72-5.323,5.332-8.786,7.83l-10.016,7.5c-3.307,2.488-6.129,5.304-8.464,8.451c-2.335,3.146-3.503,6.292-3.503,9.439
			v10.646c0,1.464,0.818,2.708,2.454,3.733c1.637,1.024,3.29,1.536,4.964,1.536h38.832c1.381,0,2.581-0.764,3.6-2.291
			c1.018-1.527,1.527-3.272,1.527-5.236c0-1.963-0.513-3.671-1.537-5.127C188.74,394.796,187.533,394.068,186.144,394.068z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M219.5,330.471c-1.564-1.017-3.291-1.527-5.181-1.527c-1.31,0-2.364,0.255-3.164,0.764l-14.398,8.727
			c-2.11,1.237-3.163,3.163-3.163,5.781c0,1.745,0.508,3.31,1.526,4.69c1.018,1.382,2.291,2.073,3.818,2.073
			c0.944,0,1.854-0.29,2.727-0.873l3.164-1.963v55.521c0,1.674,0.835,2.964,2.509,3.872c1.672,0.91,3.671,1.364,5.999,1.364
			c2.327,0,4.326-0.454,6-1.364c1.672-0.908,2.509-2.198,2.509-3.872V334.29C221.846,332.762,221.063,331.491,219.5,330.471z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M276.134,394.068h-28.765v-0.992c0.001-1.767,1.179-3.697,3.536-5.793c2.357-2.095,5.198-4.246,8.523-6.451
			c3.324-2.206,6.631-4.633,9.918-7.279c3.288-2.646,6.103-5.918,8.44-9.814c2.339-3.896,3.508-8.051,3.508-12.462
			c0-6.767-2.557-12.144-7.67-16.132c-5.113-3.988-11.064-5.982-17.856-5.982c-6.589,0-12.326,1.909-17.212,5.727
			c-4.886,3.818-7.328,8.89-7.328,15.216c0,5.89,2.51,8.835,7.535,8.835c2.655,0,4.789-0.641,6.405-1.924
			c1.613-1.282,2.422-2.792,2.422-4.528c0-2.944,0.773-5.095,2.321-6.453c1.547-1.358,3.536-2.039,5.969-2.039
			c2.799,0,4.898,0.791,6.3,2.371c1.398,1.582,2.1,3.4,2.1,5.459c0,2.574-1.198,5.221-3.593,7.941
			c-2.396,2.72-5.323,5.332-8.786,7.83l-10.016,7.5c-3.307,2.488-6.129,5.304-8.464,8.451c-2.335,3.146-3.503,6.292-3.503,9.439
			v10.646c0,1.464,0.818,2.708,2.454,3.733c1.637,1.024,3.29,1.536,4.964,1.536h38.832c1.381,0,2.581-0.764,3.6-2.291
			c1.018-1.527,1.527-3.272,1.527-5.236c0-1.963-0.513-3.671-1.537-5.127C278.73,394.796,277.523,394.068,276.134,394.068z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M336.151,396.25c-1.026-1.454-2.233-2.182-3.622-2.182h-28.765v-0.992c0-1.767,1.178-3.697,3.536-5.793
			c2.357-2.095,5.198-4.246,8.523-6.451c3.324-2.206,6.631-4.633,9.918-7.279c3.288-2.646,6.103-5.918,8.44-9.814
			c2.339-3.896,3.508-8.051,3.508-12.462c0-6.767-2.557-12.144-7.67-16.132c-5.113-3.988-11.064-5.982-17.856-5.982
			c-6.589,0-12.326,1.909-17.212,5.727c-4.886,3.818-7.328,8.89-7.328,15.216c0,5.89,2.51,8.835,7.535,8.835
			c2.655,0,4.789-0.641,6.405-1.924c1.613-1.282,2.422-2.792,2.422-4.528c0-2.944,0.773-5.095,2.321-6.453
			c1.547-1.358,3.536-2.039,5.969-2.039c2.799,0,4.898,0.791,6.3,2.371c1.398,1.582,2.1,3.4,2.1,5.459
			c0,2.574-1.198,5.221-3.593,7.941c-2.396,2.72-5.323,5.332-8.786,7.83l-10.016,7.5c-3.307,2.488-6.129,5.304-8.464,8.451
			c-2.335,3.146-3.503,6.292-3.503,9.439v10.646c0,1.464,0.818,2.708,2.454,3.733c1.637,1.024,3.29,1.536,4.964,1.536h38.832
			c1.381,0,2.581-0.764,3.6-2.291c1.018-1.527,1.527-3.272,1.527-5.236C337.688,399.414,337.174,397.706,336.151,396.25z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M365.885,330.471c-1.564-1.017-3.291-1.527-5.181-1.527c-1.31,0-2.364,0.255-3.164,0.764l-14.398,8.727
			c-2.11,1.237-3.163,3.163-3.163,5.781c0,1.745,0.508,3.31,1.526,4.69c1.018,1.382,2.291,2.073,3.818,2.073
			c0.944,0,1.854-0.29,2.727-0.873l3.164-1.963v55.521c0,1.674,0.835,2.964,2.509,3.872c1.672,0.91,3.671,1.364,5.999,1.364
			c2.327,0,4.326-0.454,6-1.364c1.672-0.908,2.509-2.198,2.509-3.872V334.29C368.229,332.762,367.448,331.491,365.885,330.471z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M399.481,330.471c-1.564-1.017-3.291-1.527-5.181-1.527c-1.31,0-2.364,0.255-3.164,0.764l-14.398,8.727
			c-2.11,1.237-3.163,3.163-3.163,5.781c0,1.745,0.508,3.31,1.526,4.69c1.018,1.382,2.291,2.073,3.818,2.073
			c0.944,0,1.854-0.29,2.727-0.873l3.164-1.963v55.521c0,1.674,0.835,2.964,2.509,3.872c1.672,0.91,3.671,1.364,5.999,1.364
			c2.327,0,4.326-0.454,6-1.364c1.672-0.908,2.509-2.198,2.509-3.872V334.29C401.826,332.762,401.044,331.491,399.481,330.471z"
        />
      </g>
    </g>
  </svg>
);
